import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InputStatus} from '../models/input-status-type';
import '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import {Router} from '@angular/router';
import {PasswordsService} from '../shared/passwords.service';
import DebitCardPassword from '../models/debit-card-password.model';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import {AuthenticationErrors, DebitCardPasswordClientModel} from '../models/client.model';
import HttpStatusCode from '../enums/http-status.enum';
import {GoogleTagManagerService} from '../shared/google-tag-manager.service';
import {RedirectService} from '../shared/redirect.service';
import {ProcessAuthenticationService} from '../shared/process-authentication.service';
import {NewServiceErrorEnum} from '../enums/new-service-error.enum';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-bdb-debit-card-password',
    templateUrl: './bdb-debit-card-password.component.html',
    styleUrls: ['./bdb-debit-card-password.component.scss']
})
export class BdbDebitCardPasswordComponent implements OnInit {
    inputStatus: InputStatus = 'ENABLED';
    inputDebitCardNumber: string;
    inputDebitCardPassword: string;
    isButtonDisabled = true;
    passwordMethod = '';
    @ViewChild('toastError') bdbAtToast: ElementRef;
    @ViewChild('loader') loader: ElementRef;
    @ViewChild('input') input: ElementRef;
    @ViewChild('inputPassword') inputPassword: ElementRef;

    constructor(
        private readonly router: Router,
        private readonly passwordService: PasswordsService,
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly googleTagManagerService: GoogleTagManagerService,
        private readonly redirectService: RedirectService,
        private readonly processAuthentication: ProcessAuthenticationService
    ) {

    }
    ngOnInit() { }

    inputCardNumberChanged(event: any): void {
        this.inputDebitCardNumber = event.detail.value;
        if (this.inputDebitCardPassword) {
            this.isButtonDisabled = this.inputDebitCardNumber.length !== 4 || this.inputDebitCardPassword.length !== 4;
        } else {
            this.isButtonDisabled = true;
        }
        if (this.inputDebitCardNumber.length <= 3) {
            this.inputStatus = 'ENABLED';
        }

    }

    inputCardPasswordChanged(event: any): void {
        this.inputDebitCardPassword = event.detail.value;
        if (this.inputDebitCardNumber) {
            this.isButtonDisabled = this.inputDebitCardNumber.length !== 4 || this.inputDebitCardPassword.length !== 4;
        } else {
            this.isButtonDisabled = true;
        }
        if (this.inputDebitCardPassword.length <= 3) {
                this.inputStatus = 'ENABLED';
        }
    }


    async buttonClick() {
        await this.loader.nativeElement.openAlert();
        const passwordRequestModel: DebitCardPassword = {
            documentType: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
            documentNumber: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
            uuid: this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH),
            password: this.inputDebitCardPassword,
            gRecaptchaResponse: null,
            cardNumber: this.inputDebitCardNumber
        };
        try {
            const isSandboxV3Active = environment.validateDebitCardKeyUseSandboxV3;
            const debitCardPasswordResponse = isSandboxV3Active ?
                await this.passwordService.debitCardWithSandboxV3(passwordRequestModel) :
                await this.passwordService.loginWithDebitCardPassword(passwordRequestModel);
            const debitCardClientModel = new DebitCardPasswordClientModel();
            let isSuccessAuthAttempt = false;
            try {
                await this.loader.nativeElement.handleCloseClick();
                isSuccessAuthAttempt =
                    this.processAuthentication.getProcessAuthenticationDebitCard(debitCardPasswordResponse, debitCardClientModel);
            } catch (error) {
                await this.loader.nativeElement.handleCloseClick();
                if (error.message === AuthenticationErrors.PASSWORD_IS_BLOCKED) {
                    this.redirectToErrorScreen(NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS);
                }
                if (error.message === AuthenticationErrors.PASSWORD_IS_WRONG) {
                    this.showDebitCardPasswordErrorToast();
                }
            }
            this.passwordMethod = this.bdbSessionStorageService.get(SessionStorageKeysEnum.PASSWORD_METHOD);
            if (isSuccessAuthAttempt) {
                this.redirectService.redirectFromAuthentication();
            } else {
                const debitCardpasswordResponseStatusCode = environment.validateDebitCardKeyUseSandboxV3 ?
                    debitCardPasswordResponse.body.code : debitCardPasswordResponse.status;
                this.handleDebitCardPasswordError(debitCardpasswordResponseStatusCode);
            }

        } catch (error) {
            console.log('something awful happened :(', error);
            this.redirectToErrorScreen(NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE);
        }
    }

    private showDebitCardPasswordErrorToast(): void {
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS);
        this.googleTagManagerService.sendError('Error: ' + NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS);
        this.bdbAtToast.nativeElement.show();
        this.inputStatus = 'ERROR';
    }

    private redirectToErrorScreen(errorCode: NewServiceErrorEnum): void {
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, errorCode);
        this.router.navigate(['error']);
    }

    private handleDebitCardPasswordError(debitCardpasswordResponseStatusCode: HttpStatusCode): void {
        if (debitCardpasswordResponseStatusCode === HttpStatusCode.UNAUTHORIZED) {
            this.redirectToErrorScreen(NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS);
        } else if (debitCardpasswordResponseStatusCode === HttpStatusCode.LOCKED) {
            this.redirectToErrorScreen(NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS);
        } else if (debitCardpasswordResponseStatusCode === HttpStatusCode.CONFLICT) {
            this.showDebitCardPasswordErrorToast();
        } else {
            this.redirectToErrorScreen(NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE);
        }
    }

    backButtonClicked($event: any): void {
        this.router.navigate(['second-factor-selector']);
    }

    closeButtonCLicked($event: any): void {
        this.router.navigate(['identity-number']);
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-debit-card-password/bdb-debit-card-password.component.ts